import React from 'react';
import { ColumnConfig } from '../../config';

interface ContactColumnProps {
  column: string;
  config: ColumnConfig;
  row: any;
}

const ContactColumn: React.FC<ContactColumnProps> = ({
  column,
  row
}) => {
  const renderDisplayValue = () => {
    if (column === 'name') {
      const name = `${row.original.first_name} ${row.original.last_name}`;
      return <span title={name}>{name}</span>;
    }

    if (column === 'client') {
      const client = row.original.client;
      return client ? <span title={client.company_name}>{client.company_name}</span> : '—';
    }

    if (column === 'email') {
      return row.original.email ? <span title={row.original.email}>{row.original.email}</span> : '—';
    }

    if (column === 'phone') {
      return row.original.phone || '—';
    }

    if (column === 'created_at') {
      return new Date(row.original.created_at).toLocaleDateString();
    }

    return row.original[column] || '';
  };

  return (
    <div className="contact-column-display">
      {renderDisplayValue()}
    </div>
  );
};

export default ContactColumn;
